export function queryURLParams(url: any) {
  const pattern = /(\w+)=(\w+)/gi //定义正则表达式
  const parames: any = {} // 定义参数对象
  url.replace(pattern, ($: any, $1: any, $2: any) => {
    parames[$1] = $2
  })
  return parames
}
